<template>
  <div id="page-product-form">
    <vs-row>
      <vs-col :class="readonly ? 'readonly-form' : ''">
        <card-page :card-title="cardTitle">
          <vue-element-loading :active="busy || loading"></vue-element-loading>
          <vue-form-generator
              ref="form"
              :model="model"
              :options="formOptions"
              :schema="schema"
          />
        </card-page>
      </vs-col>
    </vs-row>
  </div>
</template>

<script>

import FormModelMixin from '@/components/mixins/FormModelMixin';
import CardPage from '@/views/components/Views/CardPage';

export default {
  name: 'ProductForm',
  components: {
    CardPage,
  },
  props: {
    value: {
      type: Object,
      required: true
    },
    cardTitle: {
      type: String,
      required: false,
    },
    readonly: {
      type: Boolean,
      required: false,
      default: false
    },
    loading: {
      type: Boolean,
      required: false,
      default: false,
    },
    disableContact : {
      type: Boolean,
      default: false,
    },
  },
  mixins: [FormModelMixin],
  data() {
    return {
      model: {
        Contact_FK: null,
        applications: {},
      },
      schema: {
        groups: [
          {
            legend: 'General',
            styleClasses: 'w-full',
            fields: [
              {
                disabled: this.disableContact,
                type: 'vueMultiSelect',
                inputType: 'text',
                styleClasses: 'w-1/3',
                label: 'Contact Name',
                model: 'Contact_FK',
                values: () => this.userOptions,
                selectOptions: {
                  showLabels: false,
                  hideSelected: false,
                  key: 'id',
                  trackBy: 'id',
                  label: 'name',
                },
                required: !this.disableContact,
                validator: 'selectRequiredUuid',
              },
            ]
          },
          {
            styleClasses: 'w-full checkbox-group',
            fields: []
          }
        ],
      },
      formOptions: {
        validateAfterLoad: false,
        validateAfterChanged: true,
      },
      userOptions: [],
      options: [
        {
          endpoint: () => this.$api.users.listWithExternalEdentity(),
          optionsFieldName: 'userOptions',
          nameFieldName: 'Name',
          idFieldName: 'Contact_FK',
          idIsString: true,
        },
      ]
    };
  },

  async mounted() {
    await this.listApplications();
  },

  methods: {
    async listApplications() {
      try {
        const { data } = await this.$api.applications.list();
        const applications = data.data;
        const checkboxSchema = this.schema.groups[1].fields;

        applications.forEach((application) => {
          checkboxSchema.push({
            type: 'vsCheckbox',
            label: application.ApplicationName,
            styleClasses: 'w-3/12 field',
            model: `applications.application_${application.id}`,
            onChanged: (model) => {
              if (!model.applications[`application_${application.id}`]) {
                delete this.model.applications[`application_${application.id}`];                
              }
            },
          });
        });

      } catch (e) {
        console.log(e);
      }
    },
  },
};
</script>
